module.exports = __webpack_public_path__ + "kyrgyzstan.svg?cd6ff154954da94107ec381dafebe65f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kyrgyzstan.svg
// module id = 208
// module chunks = 10